import { SearchParameters } from "@/types/dto/search-filters/search-parameters";
// TODO: Fix field categorization functions in unified config to match SearchParameters exactly
// import { getArrayFieldNames, getStringFieldNames, getNumberFieldNames } from "@/config/unified-search-config";

const buildQueryString = (filters: Partial<SearchParameters>): string => {
  const params = new URLSearchParams();

  // Field type definitions (will be moved to unified config once categorization functions are fixed)
  const arrayFields: (keyof SearchParameters)[] = [
    "keyword", "Offers", "Badges", "TourStyles", "CustomerReview",
    "ActivityLevel", "TourFeature", "SaleStatus", "Continent", "Country", "Region", "City", "Duration", "months"
  ];

  const stringFields: (keyof SearchParameters)[] = [
    "MarketId", "CurrencyId", "TourId", "DepartDateFrom",
    "DepartDateTo", "sortBy", "NextCursorToken", "DirectGroupModel"
  ];

  const numberFields: (keyof SearchParameters)[] = [
    "TourLengthFrom", "TourLengthTo",
    "PriceFrom", "PriceTo", "RowCount"
  ];

  Object.entries(filters).forEach(([key, value]) => {
    const typedKey = key as keyof SearchParameters;
    // Handle array fields (can be array or single string)
    if (arrayFields.includes(typedKey)) {
      if (Array.isArray(value) && value.length > 0) {
        // Handle array values - URLSearchParams will handle encoding
        const cleanValues = value.filter(v => v && typeof v === "string" && v.trim() !== "");
        if (cleanValues.length > 0) {
          params.append(key, cleanValues.join(","));
        }
      } else if (typeof value === "string" && value.trim() !== "") {
        // Handle single string values for array fields
        params.append(key, value.trim());
      }
    }

    // Handle string fields
    else if (stringFields.includes(typedKey) && typeof value === "string" && value.trim() !== "") {
      params.append(key, value.trim());
    }

    // Handle number fields
    else if (numberFields.includes(typedKey) && typeof value === "number" && value > 0) {
      params.append(key, value.toString());
    }

    // Handle string representations of numbers (like price ranges)
    else if (numberFields.includes(typedKey) && typeof value === "string") {
      const numValue = parseFloat(value);
      if (!Number.isNaN(numValue) && numValue > 0) {
        params.append(key, value);
      }
    }
  });

  return params.toString();
};


export const getStartAndEndIndex = (
  pageSize: number,
  pageNum: number,
  totalCount: number
): {
  start: number,
  end: number
} => {
  // handle no items
  if (totalCount === 0) {
    return {
      start: 0,
      end: 0
    };
  }

  const potentialEnd = pageNum * pageSize;
  const start = potentialEnd - pageSize + 1;
  const end = Math.min(potentialEnd, totalCount);

  return {
    start,
    end
  };
};



export default buildQueryString;